import React, { useEffect, useContext, useState } from "react";
import ReactDOM from "react-dom";
import ModalContext from "./Context";

export interface ModalProps {
    show: boolean;
    title?: string | React.ReactElement;
    onClose: (e?: any) => void;
    closeTitle?: string;
    onScroll?: (e?: any) => void;
    displayCloseButton?: boolean;
    zIndexIncrement?: number;
}

const Modal: React.FC<ModalProps> = ({
    show,
    title,
    onClose,
    closeTitle,
    onScroll,
    displayCloseButton = true,
    zIndexIncrement = 0,
    children,
}) => {
    const modal = useContext(ModalContext);
    const [element, setPortalElement] = useState<HTMLElement | undefined>(undefined);

    const renderTitle = () => {
        if (!title) {
            return null;
        }
        return <div className="popup-title">{title}</div>;
    };

    useEffect(() => {
        if (modal.isMain) {
            if (show) {
                document.documentElement.classList.add("modal-open");
            } else {
                document.documentElement.classList.remove("modal-open");
            }
        }
    }, [show, modal.isMain]);

    useEffect(() => {
        const newElement = document.createElement("div") as HTMLElement;
        document.body.appendChild(newElement);
        setPortalElement(newElement);
        return () => {
            if (modal.isMain) {
                document.documentElement.classList.remove("modal-open");
            }
            document.body.removeChild(newElement);
        };
    }, [modal.isMain]);

    const handleClick = () => {
        onClose();
    };

    const zIndex = modal.overlay.zIndex + zIndexIncrement;

    if (show && element) {
        return ReactDOM.createPortal(
            <div className={`popup-filter`} style={{ zIndex }}>
                <div className="popup-export">
                    <header className="popup-header">
                        {title ? renderTitle() : null}
                        {displayCloseButton ? (
                            <button
                                type="button"
                                className="icon-cross close-popup"
                                onClick={handleClick}
                                title={closeTitle}
                            ></button>
                        ) : null}
                    </header>
                    <div className="popup-content" onScroll={onScroll}>
                        <ModalContext.Provider
                            value={{
                                overlay: { zIndex: zIndex + 30 },
                                isMain: false,
                                isOpened: true,
                            }}
                        >
                            {children}
                        </ModalContext.Provider>
                    </div>
                </div>
            </div>,
            element
        );
    }
    return null;
};

export default Modal;
